import PropTypes from 'prop-types'
import React, { Component } from 'react'

class InfoTooltip extends Component {
  render() {
    return (
      <i className={'icon-info tooltip'}>
        <span className={'top'}>
          {this.props.children ? this.props.children : this.props.dialog}
        </span>
      </i>
    )
  }
}

InfoTooltip.propTypes = {
  dialog: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
}

export default InfoTooltip
